import React from 'react';
import './Loader.css';

const Loader = () => {
    return (
        <div className="loader-container">
<div className="loader">
    <div className="loading-indicator"></div>
</div>
        </div>
    );
};

export default Loader;
